import React from "react";
// import { Container, Row, Col, Button } from "react-bootstrap";
import './heroSection.css';
import { Link } from "react-router-dom";

const HeroSection = () => {
    return (

        <>

            <div className="hero-section "  >

                <div className="hero-content">
                    <h1 className=" title">
                        Welcome to 
                    </h1>
                     <h1 className=" title">
                        Rooba Swastha Pharmaceuticals 
                    </h1>
                    


                    <p className=" tagline">

                        The Future of Generics Starts Here… 
                    </p>
                   
                    {/* <button className=" btn">
                        <Link to="/products" > Explore Our Products </Link>
                    </button> */}
                </div>

            </div>
        </>

    );
};

export default HeroSection;
